// extracted by mini-css-extract-plugin
export default {"teachersList":"TeacherList_teachersList__3J6tW","teachersListItem":"TeacherList_teachersListItem__FbjHI"};